// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MCxwu","blink":"styles_blink__nCrfk","small":"styles_small__Gp2zF","medium":"styles_medium__QYeMa","large":"styles_large__nw973"};